// extracted by mini-css-extract-plugin
module.exports = {"modal":"PatientDocumentInfo_modal__K_S7Q"};